import React from "react";
import Grid from '@mui/material/Grid';
import Box from "@mui/material/Box";

import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Particle from "../util/Particle";

import "./sideswitcher.css";

export default function Sideswicher(props) {
    const { RightInit, LeftPostSwitch, LeftInit, RightPostSwitch } = props;
    const theme = createTheme();

    const leftInit = (Component) => (
        <Box className="switch_content" id="switch_c1">
            <Component />
        </Box>
    );

    const leftPostSwitch = (Component) => (
        <Box className="switch_container__content left__post_switch">
            {/* <Particle
                darkColors={["#004f74", "#5f5800", "#245100", "#7d0000", "#810c00"]}
                lightColors={["#5bc0eb", "#fde74c", "#9bc53d", "#e55934", "#fa7921"]}
            /> */}
            <Component />
        </Box>
    );

    const rightPostSwitch = (Component) => (
        <Box className="switch_content is-hidden" id="switch_c2">
            <Component />
        </Box>
    );

    const rightInit = (Component) => <Component />;

    return (
        <ThemeProvider theme={theme}>
            <Grid className='switch_container' container component="main" sx={{ height: '100vh' }}>
                <CssBaseline />
                {rightInit(RightInit)}
                {leftPostSwitch(LeftPostSwitch)}
                <Box className="panel_switch" id="switch_container">
                    <div className="switch__circle"></div>
                    <div className="switch__circle switch__circle_top"></div>
                    {leftInit(LeftInit)}
                    {rightPostSwitch(RightPostSwitch)}
                </Box>
            </Grid>
        </ThemeProvider>
    );
};
